import useUser from "@/users/useUser";
import getUserProperties from "@/users/getUserProperties";
import { ReadingLevels } from "@/search/NewSearchPageMVP/FilterPanel/filters/ReadingLevels/ReadingLevels.component";
import { ContentTypes } from "./ContentTypes";
import { filterContainerCss } from "./Filters.styles";
import { InstructionalFeature } from "./InstructionalFeature";
import { Language } from "./Language";
import { ReadingSkills } from "./ReadingSkills";
import { SortBy } from "./SortBy";
import { Standards } from "./Standards";
import { Topics } from "./Topics";
import { TaxonomyTagsProvider } from "./Topics/TaxonomyTags";

export const Filters = () => {
  const { data: user } = useUser();
  const {
    isParent,
    isStudent,
    activeSSLicense,
    activeELALicense,
    activeScienceLicense,
  } = getUserProperties(user, { shouldUseNewUserApi: false });

  const showInstructionalFeatureFilter =
    activeELALicense ||
    activeSSLicense ||
    activeScienceLicense ||
    isStudent ||
    isParent;

  const canSeeStandardsFilter = !isStudent && !isParent;
  const canSeeReadingSkills = !isStudent && !isParent;
  const canSeeMaturityLevels = !isStudent && !isParent;
  const canSeeTaxonomyFilter = !isStudent && !isParent;

  return (
    <div css={filterContainerCss}>
      <ContentTypes />
      <SortBy />
      <Language />
      <ReadingLevels canSeeMaturityLevels={canSeeMaturityLevels} />
      {showInstructionalFeatureFilter && <InstructionalFeature />}
      {canSeeReadingSkills && <ReadingSkills />}
      {canSeeStandardsFilter && <Standards />}
      {canSeeTaxonomyFilter && (
        <TaxonomyTagsProvider>
          <Topics />
        </TaxonomyTagsProvider>
      )}
    </div>
  );
};
